import styles from "./ReferralSettingsPopup.module.scss";
import { IReferralSettings } from "../../../models/ReferralSettings";
import React, { useEffect, useRef } from "react";
import { Form, FormInstance } from "antd";
import FormItemInput from "../../../components/ui/FormItemInput/FormItemInput";
import { useTranslation } from "react-i18next";
import CustomButton from "../../../components/ui/CustomButton/CustomButton";
import { openErrorMessage, openSuccessMessage } from "../../../store/message/messageSlice";
import useAppDispatch from "../../../hooks/useAppDispatch";
import { handleError } from "../../../helper/errorHandler";
import { QueryObserverResult } from "@tanstack/react-query";
import { useReferralProgramSettingsMutations } from "../../../api/mutations";

interface ReferralSettingsProps {
  referralSettings: IReferralSettings;
  closePopup: () => void;
  getReferralSettings: () => Promise<QueryObserverResult<IReferralSettings, Error>>;
}

const ReferralSettingsPopup: React.FC<ReferralSettingsProps> = ({
  referralSettings,
  closePopup,
  getReferralSettings,
}) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const formRef = useRef<FormInstance>(null);

  const { updateReferralSettings } = useReferralProgramSettingsMutations();

  useEffect(() => {
    if (formRef.current) {
      formRef.current.setFieldsValue(referralSettings);
    }
  }, [formRef.current]);

  const onFinish = async (values: { creditsReward: string }) => {
    const creditsReward = Number(values.creditsReward);
    if (!Number.isInteger(creditsReward) || creditsReward < 1) {
      dispatch(openErrorMessage(t("ValueMustBeAWholeNumberAboveZero")));
      return;
    }

    const model = { creditsReward };
    updateReferralSettings(
      { id: referralSettings.id, model },
      {
        onSuccess: () => {
          dispatch(openSuccessMessage(t("ReferralSettingsUpdatedSuccessfully")));
          closePopup();
          getReferralSettings();
        },
        onError: (e) => handleError(e, dispatch, t),
      }
    );
  };

  return (
    <div className={styles.container}>
      <div className={styles.popup}>
        <Form
          className={styles.form}
          ref={formRef}
          name="update-referral-settings"
          onFinish={onFinish}
          autoComplete="off"
          layout={"vertical"}
        >
          <FormItemInput
            name={"creditsReward"}
            label={t("SetCreditRewardValueForAll")}
            rules={{ required: true }}
            onlyNumber={true}
          />

          <div className={styles.btnWrapper}>
            <CustomButton
              text={t("Cancel")}
              type={"button"}
              typeStyle={"outline"}
              functionOnClick={closePopup}
            />
            <CustomButton text={t("Save")} type={"submit"} typeStyle={"fill"} />
          </div>
        </Form>
      </div>
    </div>
  );
};

export default ReferralSettingsPopup;
